import { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { vdomain } from "commons/config";
import { monetize, translateType } from "commons/utils";
import { langContext } from "commons/contexts";

import style from "./style.module.scss";

const text: { [key: string]: { [key: string]: string } }= {
    nl: {
        in: "in",
        beds: "bed",
        from: "vanaf",
    },
    fr: {
        in: "À",
        beds: "CHAMBRES",
        from: "À partir de",
    }
}

interface props { refNo: string, imagesState: { [key: string]: Array<any> | any }, data: any };

function Item({ refNo, imagesState, data }: props) {
    const { itemImages, setItemImages } = imagesState;
    const history = useHistory();
    const { lang } = useContext(langContext);

    useEffect(() => {
        loadPropImage();
    //eslint-disable-next-line
    }, []);

    useEffect(() => {
    }, [itemImages]);

    async function loadPropImage() {
        if (itemImages[refNo]?.image) return;
        try {
            fetch(vdomain + "/int-getFiles", { method: "POST", body: JSON.stringify({ ref: (refNo + ""), cover: true, type: "slideshow" }) }).then(response => {

                response.json().then(data => {
                    setItemImages((itemImages: { [key: string]: string }) => {
                        var imag = data[0];

                        var newData: { [key: string]: any } = { ...itemImages };
                        var vl = imag;

                        newData[refNo] = { image: vl };

                        return newData;
                    });


                });
            });
        } catch { };
    }


    return (
        <div className={style.root} onClick={e => {
            history.push("/" + lang + `/show?ref=${refNo}`)
        }}>
            <img src={itemImages[refNo]?.image} alt="property" />
            <div className={style.textContent}>
                <div>{`${translateType(data?.type, lang) || ""} ${text[lang] ? (text[lang].in) : ""} ${data?.location || ""}`}</div>
                <div>{(text[lang]?.from || "") + " " + monetize(data?.price || "")}</div>
                <div className={style.normalCase}>{data.desc}</div>
                <div>{`${data?.region || ""} - ${data?.location || ""} - ${data?.bedrooms || ""} ${text[lang]?.beds || ""} - ${data?.type || ""} . ${refNo || ""}`}</div>
            </div>
        </div>
    );

}

export default Item;